import React from 'react';
import { mdiAccountOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { Section, F } from '../CommonUI';
import { UserAsyncAutocompleteSelect } from '../../../../components/Common';
import { fetchDelegateApprovalAutoComplete } from '../../../../store/apis/autocompleteService';

/**
 * Tab 1: Personal Data component
 * Extracted from EmployeeMaster main file to improve maintainability.
 */
function PersonalDataTab({ d, ch, off, opts }) {
  // Common mapping function for autocomplete
  const mapEmp = rawData =>
    rawData.map(item => ({
      value: item.ID,
      label: item.Name,
      name: item.Name,
      code: item.Cd,
      designation: item.Designation,
    }));

  return (
    <div className="tb anim-fade">
      <Section
        title="Employee Identity"
        cols={3}
        icon={
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <circle
              cx="12"
              cy="7"
              r="4"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        }
      >
        <F
          label="Emp Code"
          name="empCode"
          value={d.empCode}
          onChange={ch}
          disabled={off}
          maxLength={10}
        />
        <F
          label="Short Name"
          name="shortName"
          value={d.shortName}
          onChange={ch}
          disabled={off}
          maxLength={50}
        />
        <F
          label="First Name"
          name="firstName"
          value={d.firstName}
          onChange={ch}
          disabled={off}
          maxLength={40}
        />
        <F
          label="Middle Name"
          name="middleName"
          value={d.middleName}
          onChange={ch}
          disabled={off}
          maxLength={40}
        />
        <F
          label="Last Name"
          name="lastName"
          value={d.lastName}
          onChange={ch}
          disabled={off}
          maxLength={40}
        />
        <F
          label="Status"
          name="status"
          value={d.status}
          onChange={ch}
          options={opts.status}
          disabled={off}
        />
      </Section>

      <Section
        title="Personal Information"
        cols={3}
        icon={
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        }
      >
        <F
          label="Date of Birth"
          name="dateOfBirth"
          value={d.dateOfBirth}
          onChange={ch}
          type="date"
          disabled={off}
        />
        <F
          label="Gender"
          name="gender"
          value={d.gender}
          onChange={ch}
          radioOptions={['Male', 'Female']}
          disabled={off}
        />
        <F
          label="Marital Status"
          name="maritalStatus"
          value={d.maritalStatus}
          onChange={ch}
          options={opts.maritalStatus}
          disabled={off}
        />
        <F
          label="Nationality"
          name="nationality"
          value={d.nationality}
          onChange={ch}
          options={opts.nationality}
          disabled={off}
        />
        <F
          label="Religion"
          name="religion"
          value={d.religion}
          onChange={ch}
          options={opts.religion}
          disabled={off}
        />
        <F
          label="Blood Group"
          name="bloodGroup"
          value={d.bloodGroup}
          onChange={ch}
          options={opts.bloodGroup}
          disabled={off}
        />
      </Section>

      <Section
        title="Designation & Position"
        cols={3}
        icon={
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <rect
              x="2"
              y="7"
              width="20"
              height="14"
              rx="2"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        }
      >
        <F
          label="Desg (Internal)"
          name="desgInternal"
          value={d.desgInternal}
          onChange={ch}
          options={opts.desgInternal}
          disabled={off}
        />
        <F
          label="Desg (External)"
          name="desgExternal"
          value={d.desgExternal}
          onChange={ch}
          disabled={off}
          maxLength={100}
        />
        <F
          label="Desg (Visa)"
          name="desgVisa"
          value={d.desgVisa}
          onChange={ch}
          disabled={off}
          maxLength={100}
        />
        <F
          label="Appr. Group"
          name="apprGroup"
          value={d.apprGroup}
          onChange={ch}
          options={opts.apprGroup}
          disabled={off}
        />
        <F
          label="Classification-1"
          name="classification"
          value={d.classification}
          onChange={ch}
          options={opts.classification}
          disabled={off}
        />
        <F
          label="Classification-2"
          name="classification2"
          value={d.classification2}
          onChange={ch}
          options={opts.classification2}
          disabled={off}
        />
      </Section>

      <Section
        title="Organization"
        cols={3}
        icon={
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path
              d="M3 21h18M9 8h1m5 0h1M9 12h1m5 0h1M9 16h1m5 0h1M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        }
      >
        <F
          label="Entity"
          name="entity"
          value={d.entity}
          onChange={ch}
          options={opts.entity}
          disabled={off}
        />
        <F
          label="Cost Centre"
          name="costCentre"
          value={d.costCentre}
          onChange={ch}
          options={opts.costCentre}
          disabled={off}
        />
        <F
          label="Department"
          name="department"
          value={d.department}
          onChange={ch}
          options={opts.department}
          disabled={off}
        />
        <F
          label="Section"
          name="section"
          value={d.section}
          onChange={ch}
          options={opts.section}
          disabled={off}
        />
        <F
          label="Location"
          name="location"
          value={d.location}
          onChange={ch}
          options={opts.location}
          disabled={off}
        />
        <F
          label="Holiday Group"
          name="holidayGrp"
          value={d.holidayGrp}
          onChange={ch}
          options={opts.holidayGrp}
          disabled={off}
        />
        <F label="Reporting -1" name="reporting1" required>
          <UserAsyncAutocompleteSelect
            className="em-reporting-select em-reporting1-select"
            autoCompleteFn={input =>
              fetchDelegateApprovalAutoComplete({ prefixText: input })
            }
            mappedFn={mapEmp}
            onChange={e => {
              ch('reporting1', e?.code || e?.value || '');
              if (e?.name) ch('reporting1Name', e.name);
              setTimeout(() => {
                const nextInput = document.querySelector(
                  '.em-reporting2-select input',
                );
                if (nextInput) nextInput.focus();
              }, 0);
            }}
            value={
              d.reporting1
                ? {
                    value: d.reporting1,
                    label: d.reporting1Name || d.reporting1,
                    name: d.reporting1Name,
                  }
                : null
            }
            placeholder="Search by Employee name & ID"
            isClearable
            isSearchable
            isDisabled={off}
            inputIcon={
              <Icon path={mdiAccountOutline} size={0.7} color="#667085" />
            }
          />
        </F>
        <F label="Reporting -2" name="reporting2" required={false}>
          <UserAsyncAutocompleteSelect
            className="em-reporting-select em-reporting2-select"
            autoCompleteFn={input =>
              fetchDelegateApprovalAutoComplete({ prefixText: input })
            }
            mappedFn={mapEmp}
            onChange={e => {
              ch('reporting2', e?.code || e?.value || '');
              if (e?.name) ch('reporting2Name', e.name);
              setTimeout(() => {
                const nextInput = document.querySelector(
                  '.em-deptmgr-select input',
                );
                if (nextInput) nextInput.focus();
              }, 0);
            }}
            value={
              d.reporting2
                ? {
                    value: d.reporting2,
                    label: d.reporting2Name || d.reporting2,
                    name: d.reporting2Name,
                  }
                : null
            }
            placeholder="Search by Employee name & ID"
            isClearable
            isSearchable
            isDisabled={off}
            inputIcon={
              <Icon path={mdiAccountOutline} size={0.7} color="#667085" />
            }
          />
        </F>
        <F label="Dept. Manager" name="deptMgr" required>
          <UserAsyncAutocompleteSelect
            className="em-reporting-select em-deptmgr-select"
            autoCompleteFn={input =>
              fetchDelegateApprovalAutoComplete({ prefixText: input })
            }
            mappedFn={mapEmp}
            onChange={e => {
              ch('deptMgr', e?.code || e?.value || '');
              if (e?.name) ch('deptMgrName', e.name);
            }}
            value={
              d.deptMgr
                ? {
                    value: d.deptMgr,
                    label: d.deptMgrName || d.deptMgr,
                    name: d.deptMgrName,
                  }
                : null
            }
            placeholder="Search by Employee name & ID"
            isClearable
            isSearchable
            isDisabled={off}
            inputIcon={
              <Icon path={mdiAccountOutline} size={0.7} color="#667085" />
            }
          />
        </F>
      </Section>
    </div>
  );
}

export default PersonalDataTab;
